export const UpdateStatus = {
  UpToDate: 'UpToDate',
  NeedsUpdate: 'NeedsUpdate',
  NeedsUpdateStats: 'NeedsUpdateStats',
  NeedsUpdateDataSource: 'NeedsUpdateDataSource',
} as const;

export type UpdateStatus = (typeof UpdateStatus)[keyof typeof UpdateStatus];
